export class ExchangeCurrency {
  idExchangeCurrency: number;
  idExchange: number;
  idCurrency: number;
  locked: boolean;

  constructor(
    idExchangeCurrency: number,
    idExchange: number,
    idCurrency: number,
    locked: boolean,
  ) {
    this.idExchangeCurrency = idExchangeCurrency;
    this.idExchange = idExchange;
    this.idCurrency = idCurrency;
    this.locked = locked;
  }

  static fromRaw(raw: any): ExchangeCurrency {
    return new ExchangeCurrency(
      raw.idExchangeCurrency,
      raw.idExchange,
      raw.idCurrency,
      Boolean(raw.locked),
    );
  }

  clone(): ExchangeCurrency {
    return new ExchangeCurrency(
      this.idExchangeCurrency,
      this.idExchange,
      this.idCurrency,
      this.locked,
    );
  }

  toPayload(): any {
    const payload: any = {
      idExchange: this.idExchange,
      idCurrency: this.idCurrency,
      locked: this.locked,
    };
    if (this.idExchangeCurrency !== null) {
      payload.idExchangeCurrency = this.idExchangeCurrency;
    }
    return payload;
  }
}
